import { Environment } from './environment.types';
import { filterNavigation } from './navigation';

const environment: Partial<Environment> = {
  apiBaseUrl: 'https://tokueyes-qms-api.sierralabs.com/api/',
  accessTokenKey: 'Authorization',
  bearerPrefix: 'bearer',
  accessDeniedPath: '/access-denied',
  expires: 365,
  secure: true,
  tinyApiKey: '28wr7ysrep8u469n6qqpzvzmn9uyye4phxcstpwrtdh6blk1',
  recaptchaSiteKey: '6LfLJtQjAAAAAF5Eymo01VfMF2qxtY7C1r8j-MxT',
  navigation: filterNavigation(
    'Dashboard',
    'Training Admin',
    'Risk Management',
    'Documents',
    'Products',
    'Hazards',
    'CAPA',
    'SCAR',
    'Change Order',
    'Supplier Management',
    'Teams',
    'Employees',
    'Forms',
    'Workflow',
    'Task Types',
    'Templates'
  )
};

export default environment;
